import { defineType, defineField } from 'sanity';

export default defineType({
	name:   'galleryItem',
	title:  'Gallery Item',
	type:   'object',
	fields: [
		defineField({
			name:       'image',
			title:      'Image',
			type:       'image',
			options:    { hotspot: true },
			validation: Rule => Rule.required(),
		}),
		defineField({
			name:       'title',
			title:      'Title',
			type:       'localizedText',
			validation: Rule => Rule.required(),
		}),
	],
	preview: {
		select: {
			title: 'title.en',
			media: 'image',
		},
		prepare({ title, media }) {
			return {
				title: title || 'Untitled Image',
				media,
			};
		},
	},
});